import { useCallback, useRef, useState } from 'react';

import { useQueryClient } from '@mint-lib/query-client';

import { loadFolder } from '../../queries/knowledgeBase.js';

type Params = {
  onOpen: (folderId: string) => void;
};

export const useFolderNavigation = ({ onOpen }: Params) => {
  const queryClient = useQueryClient();

  const [pendingFolderId, setPendingFolderId] = useState<string | null>(null);
  const latestFolderId = useRef<string | null>(null);

  const openFolder = useCallback(
    (folderId: string, options?: { fresh?: boolean }) => {
      latestFolderId.current = folderId;
      setPendingFolderId(folderId);

      void loadFolder(queryClient, folderId, options).then(() => {
        if (latestFolderId.current !== folderId) return;

        latestFolderId.current = null;
        setPendingFolderId(null);
        onOpen(folderId);
      });
    },
    [queryClient, onOpen],
  );

  return { openFolder, pendingFolderId };
};
